import { type AppAbility } from "@adva/auth";
import { createMongoAbility } from "@casl/ability";
import { createContext } from "react";

// ADV-879: AbilityContext holds the AppAbility derived from the currently
// signed-in user. Components read it via useAbility(); guards consume it via
// <Can>. See docs/adr/0027-unified-role-model-casl-adoption.md.
export const AbilityContext = createContext<AppAbility>(createMongoAbility([]));
